import {
  WEEK_DAYS, MONTH_NAMES, CHORE_CADENCES, DAILY_CHORE_ROWS, CHORE_ROWS
} from './constants.js';

export function getCurrentWeekDay() {
  return WEEK_DAYS[(new Date().getDay() + 6) % 7];
}

export function getTodayKey() {
  return new Date().toISOString().slice(0, 10);
}

export function getMonthKey(date = new Date()) {
  return `${MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`;
}

export function addMonths(monthStr, n) {
  const [name, year] = monthStr.split(' ');
  const idx = MONTH_NAMES.indexOf(name);
  if (idx === -1 || !year) return monthStr;
  const d = new Date(parseInt(year, 10), idx + n, 1);
  return getMonthKey(d);
}

export function advanceDueDate(dateStr, fromMonth, toMonth) {
  if (!dateStr) return '';
  const [fromName, fromYear] = fromMonth.split(' ');
  const [toName, toYear] = toMonth.split(' ');
  const diff = (parseInt(toYear, 10) - parseInt(fromYear, 10)) * 12 +
    (MONTH_NAMES.indexOf(toName) - MONTH_NAMES.indexOf(fromName));
  const d = new Date(dateStr + 'T00:00:00');
  d.setMonth(d.getMonth() + diff);
  return d.toISOString().slice(0, 10);
}

export function getPreviousDueDate(chore, todayStr) {
  const today = new Date(todayStr + 'T00:00:00');
  if (chore.cadence === 'Daily') {
    const d = new Date(today);
    d.setDate(d.getDate() - 1);
    return d.toISOString().slice(0, 10);
  }
  if (chore.cadence === 'Weekly' && chore.weekDay) {
    const targetIndex = WEEK_DAYS.indexOf(chore.weekDay);
    if (targetIndex === -1) return null;
    const d = new Date(today);
    d.setDate(d.getDate() - 1);
    for (let i = 0; i < 7; i++) {
      if ((d.getDay() + 6) % 7 === targetIndex) return d.toISOString().slice(0, 10);
      d.setDate(d.getDate() - 1);
    }
  }
  return null;
}

export function isChoreDueToday(chore, currentWeekDay = getCurrentWeekDay()) {
  return chore.cadence === 'Daily' || (chore.cadence === 'Weekly' && chore.weekDay === currentWeekDay);
}

export function buildChores() {
  const seen = new Set();
  const dailyChores = DAILY_CHORE_ROWS.trim().split('\n').flatMap((row) => {
    const [title, room, cadence] = row.split('\t').map((v) => v.trim());
    const key = `${title}|${room}|${cadence}|`.toLowerCase();
    if (!title || seen.has(key)) return [];
    seen.add(key);
    return { id: crypto.randomUUID(), title, room, cadence, weekDay: undefined, streak: 0, doneToday: false, lastCompletedDate: null };
  });
  const scheduledChores = CHORE_ROWS.trim().split('\n').flatMap((row) => {
    const [title, room, , cadence, weekDay] = row.split('\t').map((v) => v.trim());
    const key = `${title}|${room}|${cadence}|${weekDay}`.toLowerCase();
    if (!title || seen.has(key)) return [];
    seen.add(key);
    return { id: crypto.randomUUID(), title, room, cadence, weekDay, streak: 0, doneToday: false, lastCompletedDate: null };
  });
  return [...dailyChores, ...scheduledChores];
}

export function getChoreKey(item) {
  return `${item.title}|${item.room || ''}|${item.cadence}|${item.weekDay || ''}`.toLowerCase();
}
